import LeadForm from './LeadForm';
import './Hero.css';

const HERO_IMG =
  'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=1200&q=80';

export default function Hero() {
  return (
    <section className="gps-hero">
      <div className="container gps-hero-grid">
        <div className="gps-hero-visual">
          <img src={HERO_IMG} alt="GPS navigation device in a vehicle dashboard" loading="eager" />
          <div className="gps-hero-badge">Trusted map update guidance</div>
        </div>

        <div className="gps-hero-form">
          <LeadForm id="quote" title="Get Your Free Map Update Quote" />
        </div>
      </div>
    </section>
  );
}
